import type { FormEvent } from 'react';
import { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

interface EarnPointsModalProps {
  show: boolean;
  onClose: () => void;
  onEarn: (points: number, activityType: 'Purchase' | 'Referral' | 'RewardRedemption', orderId?: string) => Promise<void>;
}

export const EarnPointsModal = ({ show, onClose, onEarn }: EarnPointsModalProps) => {
  const [points, setPoints] = useState('');
  const [activityType, setActivityType] = useState<'Purchase' | 'Referral' | 'RewardRedemption'>('Purchase');
  const [orderId, setOrderId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await onEarn(parseInt(points), activityType, orderId || undefined);
      setPoints('');
      setActivityType('Purchase');
      setOrderId('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Earn Points</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Points</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter points to earn"
              value={points}
              onChange={(e) => setPoints(e.target.value)}
              required
              min="1"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Activity Type</Form.Label>
            <Form.Select value={activityType} onChange={(e) => setActivityType(e.target.value as 'Purchase' | 'Referral' | 'RewardRedemption')} required>
              <option value="Purchase">Purchase</option>
              <option value="Referral">Referral</option>
              <option value="RewardRedemption">Reward Redemption</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Order ID (Optional)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter related order ID"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="success" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Processing...' : 'Earn Points'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
